import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const PromoStickBanner = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    setTimeout(() => {
      const pricingSection = document.getElementById('promo-pricing-section');
      if (pricingSection) {
        pricingSection?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };

  return (
    <div 
      onClick={handleClick}
      className="w-full bg-gradient-to-r from-orange-500 via-orange-600 to-orange-500 py-2 px-4 cursor-pointer hover:from-orange-600 hover:via-orange-700 hover:to-orange-600 transition-all duration-300 shadow-md"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-white text-sm md:text-base font-medium text-center">
        <Icon name="Flame" className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0 animate-pulse" />
        <span className="leading-tight">
          <strong>🌞 Offre Été 2026 :</strong> Barrique noire 270L OFFERTE + Transport complet à 160€ TTC → Valable jusqu'en septembre 2026
        </span>
      </div>
    </div>
  );
};

export default PromoStickBanner;